import type {
  OrchidDriveData,
  OrchidDriveDirectory,
  OrchidDriveFile,
} from "contexts/orchid-drive/types";
import { orderBy } from "lodash";
import { useMemo } from "react";
import { isDriveDirectoryAvailable } from "utils/isDriveDirectoryNotifyAvailable";
import { isDriveFileAvailable } from "utils/isDriveFileNotifyAvailable";

export type TDataInView = {
  filesInView: OrchidDriveFile[];
  foldersInView: OrchidDriveDirectory[];
};

/**
 * take orchid drive data and return data (files / folders) in given path
 */
const useOrchidDriveDataInView = (
  orchidDriveData: OrchidDriveData,
  orderByField = "createDatetime",
  orderDescending = true,
) => {
  const dataInView = useMemo((): TDataInView => {
    if (!orchidDriveData) {
      return {
        filesInView: [],
        foldersInView: [],
      };
    }
    const nextFilesInView = orderBy(
      Object.values(orchidDriveData.files).filter(isDriveFileAvailable),
      orderByField,
      orderDescending ? "desc" : "asc",
    );
    const nextFoldersInView = orderBy(
      Object.values(orchidDriveData.directories).filter(
        isDriveDirectoryAvailable,
      ),
      orderByField,
      orderDescending ? "desc" : "asc",
    );

    return {
      filesInView: nextFilesInView,
      foldersInView: nextFoldersInView,
    };
  }, [orchidDriveData, orderByField, orderDescending]);
  return dataInView;
};

export default useOrchidDriveDataInView;
